import type { IInitializeProduct } from '../../hooks/useInitializeProduct';
import type { IProduct } from '../../types';
import type { ReactNode } from 'react';

import { useInitializeProduct } from '../../hooks/useInitializeProduct';
import { createContext, useContext, useMemo } from 'react';

export type IProductContext = IInitializeProduct;
export interface IProductProvider {
  children: ReactNode;
  productId?: IProduct['id'];
}

export const ProductContext = createContext<IProductContext | undefined>(undefined);

export const ProductProvider: React.FC<IProductProvider> = ({ children, productId }) => {
  const internalProduct = useInitializeProduct({ productId });

  const contextValue = useMemo(
    () => ({
      ...internalProduct,
    }),
    [internalProduct],
  );

  return <ProductContext.Provider value={contextValue}>{children}</ProductContext.Provider>;
};

export const useProductContext = () => {
  const context = useContext(ProductContext);
  if (!context) {
    throw new Error('useProductContext must be used within a ProductProvider');
  }
  return context;
};
